import React /* , { useState } */ from 'react';
import PropTypes from 'prop-types';

import styles from './SimpleTextList.module.scss';

import { isDayToday } from '../../utils/date-utils';

const SimpleTextList = ({ list, onClickItem, selectedItemIndex }) => {
  // const [selectedDayIndex, setSelectedDayIndex] = useState(0);

  const handleOnClick = (index) => {
    // setSelectedDayIndex(index);
    if (onClickItem) {
      onClickItem(index);
    }
  };

  return (
    <div className={styles.container}>
      {list.map((element, index) => {
        const isElementDatToday = isDayToday(element.day);
        return (
          <div
            key={`elem-${element.dayName}`}
            onClick={() => handleOnClick(index)}
          >
            <p
              className={
                index === selectedItemIndex
                  ? styles.highlighted
                  : styles.regular
              }
            >
              {isElementDatToday ? 'TODAY' : element.dayName}
            </p>
          </div>
        );
      })}
    </div>
  );
};

SimpleTextList.propTypes = {
  list: PropTypes.arrayOf(String).isRequired,
  onClickItem: PropTypes.func,
  selectedItemIndex: PropTypes.number,
};

SimpleTextList.defaultProps = {
  onClickItem: null,
  selectedItemIndex: 0,
};

export default SimpleTextList;
